import React from "react";
import styled from "styled-components";

const HeroSection = ({heroData = {}}) => {
  const {title = "", subtitle = "", heroImage = "", heroImageMob = ""} = heroData;

  return (
    <HeroContainer>
      <HeroContent>
        <HeroTitle>
          {Array.isArray(title)
            ? title.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index !== title.length - 1 && <br />}
              </React.Fragment>
            ))
            : title}
        </HeroTitle>
        <HeroSubtitle>
          {subtitle}
        </HeroSubtitle>
      </HeroContent>
      <HeroImageWrapper>
        <HeroImage
          alt="hero-image"
          src={heroImage}
          width={1000}
          height={600}
          decoding="async"
          sizes="(max-width: 768px) 0px, 70vw"
        />

        <HeroImageMobile
          alt="hero-image-mobile"
          src={heroImageMob}
          width={1000}
          height={600}
          decoding="async"
          fetchPriority="high"
          sizes="(max-width: 768px) 90vw, 0px"
        />
      </HeroImageWrapper>
    </HeroContainer>
  );
};

const HeroContainer = styled.section`
  width: 100%;
  background: #f8f5ff;
  padding: 7rem 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    padding: 3rem 0 3rem 0;
  }
`;

const HeroContent = styled.div`
  text-align: center;
  margin-bottom: 12px;
`;

const HeroTitle = styled.h1`
  font-family: 'DM Serif Display';
  font-size: 7.2rem;
  font-weight: 400;
  color: #1C1C1C;
  margin-bottom: 4rem;
  line-height: 80px;

  @media (max-width: 768px) {
    font-size: 3.4rem;
    margin: 0 auto 2.6rem;
    max-width: 320px;
    line-height: 40px;
  }
`;

const HeroSubtitle = styled.p`
  font-family: 'Lato';
  font-size: 2rem;
  color: #7E7E7E;
  font-weight: 400;
  line-height: 3.2rem;
  max-width: 880px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 20px;
    max-width: 320px;
  }
`;

const HeroImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media (max-width: 768px) {
    aspect-ratio: 1000 / 600;
    max-width: 100%;
  }
`;

const HeroImage = styled.img`
  width: 150%;
  height: auto;
  margin: 0 auto;
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

const HeroImageMobile = styled.img`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    max-width: 320px;
    height: auto;
    max-height: 100%;
    margin: 0 auto;
    margin-top: 5rem;
    object-fit: contain;
  }
`;

const HeroCTAButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 24px;

  @media (max-width: 768px) {
    align-items: center;
    gap: 12px;
  }
`;

const LoginButton = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: inline-block ;
    font-family: 'Lato';
    background: #ffffff;
    color: #6725F4;
    border: 2px solid #6725F4;
    border-radius: 100px;
    padding: 12px 32px;
    font-size: 1.8rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #f8f5ff;
    }
      width: 120px;
      height: 50px;
      font-size: 1.6rem;
  }
`;

const SignUpButton = styled.button`
  display: none;

  @media (max-width: 768px) {
  display: inline-block;
  background: #6725F4;
  color: #ffffff;
  border: none;
  border-radius: 100px;
  padding: 12px 32px;
  font-size: 1.8rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #5a1fd8;
  }
    width: 120px;
    height: 50px;
    font-size: 1.6rem;
  }
`;

export default HeroSection;
